import { callAPI } from "../../network/networkConnection";
import { showRestrictedSearchPopup } from "../../website/helper/utils";

const API_URL = process.env.REACT_APP_APIUrl;

/**
 * Search Autocomplete Service
 * Provides autocomplete suggestions for search keywords
 */
export const SearchAutocompleteService = {
  /**
   * Get autocomplete suggestions based on search query
   * @param {string} query - The search query
   * @param {number} limit - Maximum number of suggestions to return (default: 10)
   * @returns {Promise<Array>} Array of suggestion objects with keyword and searchCount
   */
  getSuggestions: async (query, limit = 10) => {
    try {
      const url = `${API_URL}admin/search-products/autocomplete?query=${encodeURIComponent(query)}&limit=${limit}`;
      // console.log('[SearchAutocompleteService] Calling API:', url);

      const response = await callAPI(
        url,
        "GET",
        {
          "Content-Type": "application/json",
        }
      );

      // console.log('[SearchAutocompleteService] Response:', response);

      if (response.data && response.data.suggestions) {
        // console.log('[SearchAutocompleteService] Returning suggestions:', response.data.suggestions);
        return response.data.suggestions;
      }

      // console.log('[SearchAutocompleteService] No suggestions in response');
      return [];
    } catch (error) {
      console.error("[SearchAutocompleteService] Error fetching autocomplete suggestions:", error);
      if (error?.status === 400) {
        showRestrictedSearchPopup();
      }
      return [];
    }
  },
};
